import createClient from "openapi-fetch";
import { serviceURL } from "../../utils/service-url";

import type { paths } from "../../__definitions__/huddle.changeengine.com-definitions";

export const huddle = createClient<paths>({
  baseUrl: serviceURL("huddle"),
  headers: {
    "Content-Type": "application/json",
  },
});
